import React, { useEffect, useState } from "react";
import "./reportPreview.css";
import { useLocation } from "react-router-dom";
import axios from "axios";
import baseUrl from "../../config/baseUrl";
import logoicn from "../../assets/images/merchantnewlogo.svg";
import {
  Box,
  CircularProgress 
} from "@mui/material";
import { useStateContext } from "../../context/ContextProvider";

const ReportPreview = () => {
  const { dropdownMerchant } = useStateContext();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const from = queryParams.get("from");
  const to = queryParams.get("to");
  const [loading, setLoading] = useState(false);
  const [formState, setFormState] = useState({
    name: "",
    email: "",
    id: "",
    currency: "",
  });

  const [merchantCharges, setMerchantCharges] = useState({
    UPI: "",
    CARD: "",
    NETBANKING: "",
    WALLET: "",
    QR: "",
    VAOFFLINE: "",
    PAYOUT: "",
    GST: "",
    REFUND: "",
    CHARGEBACK: "",
  });

  const [depositData, setDepositData] = useState([]);
  const [payoutData, setPayoutData] = useState([]);
  const [settlementData, setSettlementData] = useState([]);

  const handlePrint = () => window.print();
  const handleBack = () => window.history.back();

  const merchantData = async () => {
    try {
      setLoading(true)
      const auth = sessionStorage.getItem("user");
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: `Bearer ${auth}`,
        },
      };

      const result = await axios.post(
        `${baseUrl}/merchantStatement`,
        { from, to, id: dropdownMerchant },
        config
      );
      setFormState(result.data.userData || []);
      setMerchantCharges(result.data.charges || []);
      setDepositData(result.data.payin_summary || []);
      setPayoutData(result.data.payout_summary || []);
      setSettlementData(result.data.settlement_summary || []);
      // console.log(merchantCharges);
    } catch (error) {
      console.log("Error fetching report:", error);
    } finally{
      setLoading(false)
    }
  };

  useEffect(() => {
    merchantData();
  }, [from, to, dropdownMerchant]);

  const merchantChargesData = [
    { payment_type: "UPI", charges: merchantCharges.UPI ? merchantCharges.UPI : 0 },
    { payment_type: "CARD", charges: merchantCharges.CARD ? merchantCharges.CARD : 0 },
    { payment_type: "NETBANKING", charges: merchantCharges.NETBANKING ? merchantCharges.NETBANKING : 0 },
    { payment_type: "WALLET", charges: merchantCharges.WALLET ? merchantCharges.WALLET : 0 },
    { payment_type: "QR", charges: merchantCharges.QR ? merchantCharges.QR : 0 },
    { payment_type: "VAOFFLINE", charges: merchantCharges.VAOFFLINE ? merchantCharges.VAOFFLINE : 0 },
    { payment_type: "PAYOUT", charges: merchantCharges.PAYOUT ? merchantCharges.PAYOUT : 0 },
    { payment_type: "GST", charges: merchantCharges.GST ? merchantCharges.GST : 0 },
    { payment_type: "REFUND", charges: merchantCharges.REFUND ? merchantCharges.REFUND : 0 },
    { payment_type: "CHARGEBACK", charges: merchantCharges.CHARGEBACK ? merchantCharges.CHARGEBACK : 0 },
  ];

  // Calculate totals
  const totals = depositData.reduce(
    (acc, curr) => {
      acc.successful_txns += curr.successful_txns || 0;
      acc.successful_amount += curr.successful_amount || 0;
      acc.successful_charges +=
        (curr.successful_payin_charges || 0) +
        (curr.successful_gst_charges || 0);
      return acc;
    },
    {
      successful_txns: 0,
      successful_amount: 0,
      successful_charges: 0,
    }
  );

  const totalCBR = depositData.reduce(
    (acc, curr) => {
      acc.chargeback_txns += curr.chargeback_txns || 0;
      acc.chargeback_amount += curr.chargeback_amount || 0;
      acc.chargeback_charges += 400 * curr.chargeback_txns || 0;
      return acc;
    },
    {
      chargeback_txns: 0,
      chargeback_amount: 0,
      chargeback_charges: 0,
    }
  );

  const totalRef = depositData.reduce(
    (acc, curr) => {
      acc.refund_txns += curr.refund_txns || 0;
      acc.refund_amount += curr.refund_amount || 0;
      acc.refund_charges += 400 * curr.refund_txns || 0;
      return acc;
    },
    {
      refund_txns: 0,
      refund_amount: 0,
      refund_charges: 0,
    }
  );

  const totalpay = payoutData.reduce(
    (acc, curr) => {
      acc.successful_txns += curr.successful_txns || 0;
      acc.successful_amount += curr.successful_amount || 0;
      acc.payout_charges +=
        (curr.successful_akonto_charge || 0) +
        (curr.successful_bank_charges || 0) +
        +(curr.successful_gst_amount || 0);
      return acc;
    },
    {
      successful_txns: 0,
      successful_amount: 0,
      payout_charges: 0,
    }
  );

  const totalsettlement = settlementData.reduce(
    (acc, curr) => {
      acc.successful_txns += curr.successful_txns || 0;
      acc.successful_amount += curr.successful_amount || 0;
      acc.settlement_charges += curr.successful_charges || 0;
      return acc;
    },
    {
      successful_txns: 0,
      successful_amount: 0,
      settlement_charges: 0,
    }
  );

  return (
    <>
      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" my={3}>
          <CircularProgress sx={{color: "#ff6600"}} />
        </Box>
      ) : (
        <div className="report-container">
          <div
            className="report-container"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              background: "#f5f7fa",
              padding: "1.5rem 2rem",
              borderRadius: "1rem",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
              maxWidth: "1000px",
              margin: "2rem auto",
              flexWrap: "wrap",
              gap: "1.5rem",
            }}
          >
            {/* Left - Logo */}
            <div style={{ flex: "1", display: "flex", alignItems: "center" }}>
              <img
                src={logoicn}
                alt="Logo"
                style={{ height: "60px", objectFit: "contain" }}
              />
            </div>

            {/* Center - Merchant Info */}
            <div
              style={{
                flex: "2",
                background: "#ffffff",
                borderRadius: "1rem",
                padding: "1rem 1.5rem",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
                minWidth: "250px",
              }}
            >
              <p
                style={{
                  fontWeight: "bold",
                  fontSize: "1rem",
                  marginBottom: "0.6rem",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <i
                  className="fas fa-user-tag"
                  style={{ color: "#4a90e2", marginRight: "8px" }}
                ></i>
                Merchant:{" "}
                <span style={{ marginLeft: "6px", color: "#2d2d2d" }}>
                  ({formState.id}) {formState.name}
                </span>
              </p>
              <p
                style={{
                  fontWeight: "bold",
                  fontSize: "1rem",
                  marginBottom: "0.6rem",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <i
                  className="fas fa-envelope"
                  style={{ color: "#4a90e2", marginRight: "8px" }}
                ></i>
                Email:{" "}
                <span style={{ marginLeft: "6px", color: "#2d2d2d" }}>
                  {formState.email}
                </span>
              </p>
              <p
                style={{
                  fontWeight: "bold",
                  fontSize: "1rem",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <i
                  className="fas fa-coins"
                  style={{ color: "#4a90e2", marginRight: "8px" }}
                ></i>
                Currency:{" "}
                <span style={{ marginLeft: "6px", color: "#2d2d2d" }}>
                  {formState.currency}
                </span>
              </p>
            </div>

            {/* Right - Buttons */}
            <div className="no-print" style={{ flex: "1", textAlign: "right" }}>
              <button
                onClick={handlePrint}
                style={{
                  background: "#4a90e2",
                  color: "white",
                  border: "none",
                  padding: "0.6rem 1rem",
                  borderRadius: "8px",
                  cursor: "pointer",
                  marginRight: "0.8rem",
                }}
              >
                🖨️ Print
              </button>
              <button
                onClick={handleBack}
                style={{
                  background: "#ff4d4f",
                  color: "white",
                  border: "none",
                  padding: "0.6rem 1rem",
                  borderRadius: "8px",
                  cursor: "pointer",
                }}
              >
                🔙 Back
              </button>
            </div>
          </div>

          <div className="section">
            <h3 className="section-title">DEPOSIT DETAILS</h3>
          </div>

          <table className="report-table">
            <thead>
              <tr>
                <th>Payment Type</th>
                <th>Successful Txns.</th>
                <th>Amount</th>
                <th>Charges</th>
              </tr>
            </thead>
            <tbody>
              {depositData.map((item, index) => {
                const totalCharges =
                  (item.successful_payin_charges || 0) +
                  (item.successful_gst_charges || 0);
                return (
                  <tr key={index}>
                    <td>Deposit via {item.payment_type}</td>
                    <td>{item.successful_txns}</td>
                    <td>{item.successful_amount.toFixed(2)}</td>
                    <td>{totalCharges.toFixed(2)}</td>
                  </tr>
                );
              })}

              <tr className="total-row">
                <td colSpan="1">Total:</td>
                <td>{totals.successful_txns}</td>
                <td>{totals.successful_amount.toFixed(2)}</td>
                <td>{totals.successful_charges.toFixed(2)}</td>
              </tr>
            </tbody>
          </table>

          <div className="company-info">
            <div className="account-box">
              <p style={{ fontWeight: "bold" }}>
                Total Deposits for selected time period {from} to {to}
                <span className="amount-right">
                  {totals.successful_amount.toFixed(2) -
                    totals.successful_charges.toFixed(2)}
                </span>
              </p>
            </div>
          </div>

          <div className="section">
            <h3 className="section-title">REFUND DETAILS</h3>
          </div>

          <table className="report-table">
            <thead>
              <tr>
                <th>Payment Type</th>
                <th>Refund Txns.</th>
                <th>Amount</th>
                <th>Charges</th>
              </tr>
            </thead>
            <tbody>
              {depositData.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>Deposit via {item.payment_type}</td>
                    <td>{item.refund_txns}</td>
                    <td>{item.refund_amount}</td>
                    <td>{400 * item.refund_txns}</td>
                  </tr>
                );
              })}

              <tr className="total-row">
                <td colSpan="1">Total:</td>
                <td>{totalRef.refund_txns}</td>
                <td>{totalRef.refund_amount.toFixed(2)}</td>
                <td>{totalRef.refund_charges.toFixed(2)}</td>
              </tr>
            </tbody>
          </table>

          <div className="company-info">
            <div className="account-box">
              <p style={{ fontWeight: "bold" }}>
                Total Refunds for selected time period {from} to {to}
                <span className="amount-right">
                  {totalRef.refund_amount.toFixed(2) - totalRef.refund_charges}
                </span>
              </p>
            </div>
          </div>

          <div className="section">
            <h3 className="section-title">CHARGEBACK DETAILS</h3>
          </div>

          <table className="report-table">
            <thead>
              <tr>
                <th>Payment Type</th>
                <th>Chargeback Txns.</th>
                <th>Amount</th>
                <th>Charges</th>
              </tr>
            </thead>
            <tbody>
              {depositData.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>Deposit via {item.payment_type}</td>
                    <td>{item.chargeback_txns}</td>
                    <td>{item.chargeback_amount.toFixed(2)}</td>
                    <td>{400 * item.chargeback_txns}</td>
                  </tr>
                );
              })}

              <tr className="total-row">
                <td colSpan="1">Total:</td>
                <td>{totalCBR.chargeback_txns}</td>
                <td>{totalCBR.chargeback_amount.toFixed(2)}</td>
                <td>{totalCBR.chargeback_charges.toFixed(2)}</td>
              </tr>
            </tbody>
          </table>

          <div className="company-info">
            <div className="account-box">
              <p style={{ fontWeight: "bold" }}>
                Total Chargebacks for selected time period {from} to {to}
                <span className="amount-right">
                  {totalCBR.chargeback_amount.toFixed(2) -
                    totalCBR.chargeback_charges}
                </span>
              </p>
            </div>
          </div>

          <div className="section">
            <h3 className="section-title">WITHDRAWAL DETAILS</h3>
          </div>

          <table className="report-table">
            <thead>
              <tr>
                <th>Payment Type</th>
                <th>Successful Payouts</th>
                <th>Amount</th>
                <th>Charges</th>
              </tr>
            </thead>
            <tbody>
              {payoutData.map((item, index) => {
                const totalCharges =
                  (item.successful_akonto_charge || 0) +
                  (item.successful_bank_charges || 0) +
                  (item.successful_gst_amount || 0);
                return (
                  <tr key={index}>
                    <td>Withdrawal via {item.trx_type}</td>
                    <td>{item.successful_txns}</td>
                    <td>{item.successful_amount.toFixed(2)}</td>
                    <td>{totalCharges.toFixed(2)}</td>
                  </tr>
                );
              })}

              <tr className="total-row">
                <td colSpan="1">Total:</td>
                <td>{totalpay.successful_txns}</td>
                <td>{totalpay.successful_amount.toFixed(2)}</td>
                <td>{totalpay.payout_charges.toFixed(2)}</td>
              </tr>
            </tbody>
          </table>
          <div className="company-info">
            <div className="account-box">
              <p style={{ fontWeight: "bold" }}>
                Total Payouts for selected time period {from} to {to}
                <span className="amount-right">
                  {Number(totalpay.successful_amount.toFixed(2)) +
                    Number(totalpay.payout_charges.toFixed(2))}
                </span>
              </p>
            </div>
          </div>

          <div className="section">
            <h3 className="section-title">SETTLEMENT DETAILS</h3>
          </div>

          <table className="report-table">
            <thead>
              <tr>
                <th>Payment Type</th>
                <th>Successful Settlements</th>
                <th>Amount</th>
                <th>Charges</th>
              </tr>
            </thead>
            <tbody>
              {settlementData.map((item, index) => {
                const totalCharges = item.successful_charges || 0;
                return (
                  <tr key={index}>
                    <td>Settlement via {item.settlementType}</td>
                    <td>{item.successful_txns}</td>
                    <td>{item.successful_amount.toFixed(2)}</td>
                    <td>{totalCharges.toFixed(2)}</td>
                  </tr>
                );
              })}

              <tr className="total-row">
                <td colSpan="1">Total:</td>
                <td>{totalsettlement.successful_txns}</td>
                <td>{totalsettlement.successful_amount.toFixed(2)}</td>
                <td>{totalsettlement.settlement_charges.toFixed(2)}</td>
              </tr>
            </tbody>
          </table>
          <div className="company-info">
            <div className="account-box">
              <p style={{ fontWeight: "bold" }}>
                Total Settlements for selected time period {from} to {to}
                <span className="amount-right">
                  {totalsettlement.successful_amount.toFixed(2) -
                    totalsettlement.settlement_charges.toFixed(2)}
                </span>
              </p>
            </div>
          </div>

          <div className="section">
            <h3 className="section-title">UBANK CHARGES</h3>
          </div>

          <table className="report-table">
            <thead>
              <tr>
                <th>DESCRIPTION</th>
                {merchantChargesData.map((item, index) => (
                  <th key={index}>{item.payment_type}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Charges</td>
                {merchantChargesData.map((item, index) => (
                  <td key={index}>{item.charges}</td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};

export default ReportPreview;
